import { format } from 'owa-localize';
import { makePatchRequest } from 'owa-ows-gateway';
import { ConnectedAccountResponse } from '../contracts/ConnectedAccountResponse';
import { ErrorResponse } from '../contracts/ErrorResponse';

const refreshConnectedAccountAccessTokenUrl: string = 'ows/beta/ConnectedAccounts/refreshtoken/{0}';

export async function refreshConnectedAccountAccessToken(
    id: string
): Promise<ConnectedAccountResponse | ErrorResponse> {
    return await makePatchRequest(
        format(refreshConnectedAccountAccessTokenUrl, id),
        null,
        undefined,
        false
    );
}
